// extracted by mini-css-extract-plugin
export var acitonButtons = "_lt-0";
export var additionalIcon = "_lt-f";
export var block = "_lt-1";
export var blockContent = "_lt-7";
export var blockDescription = "_lt-8";
export var blockIcon = "_lt-9";
export var blockTitle = "_lt-6";
export var border = "_lt-a";
export var center = "_lt-l";
export var edge = "_lt-b";
export var edgeLabel = "_lt-c";
export var edgePath = "_lt-d";
export var error = "_lt-e";
export var flowchart = "_lt-g";
export var flowchartContent = "_lt-h";
export var highlighted = "_lt-3";
export var hover = "_lt-4";
export var icon = "_lt-i";
export var left = "_lt-m";
export var navButton = "_lt-j";
export var navButtons = "_lt-k";
export var right = "_lt-n";
export var selected = "_lt-2";
export var small = "_lt-5";